/* istanbul ignore file */
import { Badge } from 'framework/ui/mui-builder';
import { FieldBadgeProps } from 'framework/ui/ui-builder';

const StudentBadge = (props: FieldBadgeProps) => {
  return (
    <Badge color="success" sx={{ ml: 1 }} {...props}>
      Student
    </Badge>
  );
};

export default StudentBadge;
